import { useEffect } from 'react';
import { useRouter } from '@tanstack/react-router';

import { useAuthenticated } from 'stores/useAuthStore';
import { useEntityAdminEntitySwitchSync } from 'containers/EntityAdmin/useEntityAdmin';

import { useOrganizations } from 'containers/Organizations/hooks/useOrganizations';
import { useUserAccountSync } from 'containers/User/hooks/useUserAccountSync';
import { useAppRealtime } from 'hooks/useAppRealtime';
import { useTenantScopeReset } from 'hooks/useTenantScopeReset';

export function useAppBootstrap() {
  const router = useRouter();
  const authenticated = useAuthenticated();

  useOrganizations();
  useUserAccountSync();
  useAppRealtime();

  useEntityAdminEntitySwitchSync();

  useTenantScopeReset();

  useEffect(() => {
    if (!authenticated) {
      router.invalidate();
    }
  }, [authenticated, router]);
}
